 
'use client';

import { useEffect } from 'react';

import { getRuntimeOrg } from '@/utils/runtimeOrg';

interface RuntimeConfigInitializerProps {
  onOrgDetected?: (org: string) => void;
}

export default function RuntimeConfigInitializer({
  onOrgDetected,
}: RuntimeConfigInitializerProps) {
  useEffect(() => {
    const currentOrg = getRuntimeOrg();

    onOrgDetected?.(currentOrg);
  }, [onOrgDetected]);

  return null;
}
